import { PAGE_LEVEL } from '@/constants';

/**
 * 资讯模块
 */
export default {
  meta: { localeModules: ['news'] },
  path: '/news',
  redirect: '/news/list',
  children: [
    {
      path: 'list',
      name: 'news',
      component: () => import('@/pages/news/index.vue'),
      meta: {
        name: 'routers.news',
        componentName: 'NewsIndex',
        pageLevel: PAGE_LEVEL.FIRST,
        keepAlive: true
      }
    },
    {
      // 资讯详情
      path: 'detail',
      name: 'newsDetail',
      component: () => import('@/pages/news/detail.vue'),
      meta: {
        name: 'routers.news_detail',
        componentName: 'NewsDetail',
        parent: '/news/list',
        electronSingle: true
      }
    },
    {
      path: 'officialAccountDetail',
      name: 'officialAccountDetail',
      component: () => import('@/pages/news/officialAccountDetail.vue'),
      meta: {
        name: 'routers.official_account_detail',
        componentName: 'OfficialAccountDetail',
        parent: '/news/list',
        electronSingle: true
      }
    }
  ]
};
